const styles = {
    clearIcon: {
        position: 'absolute',
        right: '34px',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    inputShell: {
        // position: 'relative'
    },
    input: {
        background: 'transparent',
        border: 'none',
        outline: 'none',
        boxShadow: 'none',
        width: '100%',
        padding: '0 46px 0 0',
        margin: 0,
        font: 'inherit',
        color: '#000000'
    },
    menuContainer: {
        position: 'absolute',
        top: 'calc(100% + 2px)',
        left: 0,
        width: '100%'
    },
    dropdownList: {
        maxHeight: '260px',
        overflowY: 'auto',
        position: 'relative'
    }
}

export default styles
